import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {unassignUserFromConferences} from 'src/openapi/admin/apis/UserConferencesApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
    conferenceIds: number[],
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveConferences = ({userId, conferenceIds, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        unassignUserFromConferences({userId, requestBody: conferenceIds}),
    ), [conferenceIds, userId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
